// type Entry<T> = {
//   [K in keyof T]: [K, T[K]];
// }[keyof T];

// export default function <T extends object>(
//   obj: T,
//   fn: (entry: Entry<T>, i: number, arr: Entry<T>[]) => boolean
// ): Partial<T> {
//   return Object.fromEntries(
//     (Object.entries(obj) as Entry<T>[]).filter(fn)
//   ) as Partial<T>;
// }

// usage :=> filterObject(obj, ([k, v]) => v === "target")

type Filter<T, K> = (item: T, key?: K) => boolean;

export default function <T extends any>(
  obj: Record<number | string | symbol, T>,
  f: Filter<T, number | string | symbol>
): Record<number | string | symbol, T> {
  const copy: Record<number | string | symbol, T> = {};

  for (const key in obj) {
    if (f(obj[key], key)) {
      copy[key] = obj[key];
    }
  }

  return copy;
}
